
export default {
  text () {
    console.log("测试，测试！！！")
  },
  down (data, fileName) {
    // const data = "这是一段生成的数据";
    // const fileName = "pape.md";
    const blob = new Blob([data], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.download = fileName;
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
  addlistener (handleKeyDown, handleKeyUp) {
    document.addEventListener('keydown', handleKeyDown)
    document.addEventListener('keyup', handleKeyUp)
  },
  delListener (handleKeyDown, handleKeyUp) {
    document.removeEventListener('keydown', handleKeyDown)
    document.removeEventListener('keyup', handleKeyUp)
  },
  sortSection (section) {
    for (let i = 0; i < section.length; i++) {
      if (section[i].sequence == 0) {
        let tmp = section[i]
        section[i] = section[0]
        section[0] = tmp
        break;
      }
    }

    for (let i = 0; i < section.length; i++) {
      for (let j = i + 1; j < section.length; j++) {
        if (section[j].sequence == section[i].id) {
          let tmp = section[i + 1]
          section[i + 1] = section[j]
          section[j] = tmp
          break
        }
      }
    }
  },
  sort (chapters) {
    for (let i in chapters) {
      if (chapters[i].sequence == 0) {
        let tmp = chapters[i]
        chapters[i] = chapters[0]
        chapters[0] = tmp
        break;
      }
    }

    for (let i = 0; i < chapters.length; i++) {
      for (let j = i + 1; j < chapters.length; j++) {
        if (chapters[j].sequence == chapters[i].id) {
          let tmp = chapters[i + 1]
          chapters[i + 1] = chapters[j]
          chapters[j] = tmp
          break;
        }
      }
    }

    for (let k in chapters) {
      for (let i = 0; i < chapters[k].sections.length; i++) {
        if (!chapters[k].sections[i].sequence || chapters[k].sections[i].sequence == 0) {
          let tmp = chapters[k].sections[i]
          chapters[k].sections[i] = chapters[k].sections[0]
          chapters[k].sections[0] = tmp
          break;
        }
      }

      for (let i = 0; i < chapters[k].sections.length; i++) {
        for (let j = i + 1; j < chapters[k].sections.length; j++) {
          if (chapters[k].sections[j].sequence == chapters[k].sections[i].id) {
            let tmp = chapters[k].sections[i + 1]
            chapters[k].sections[i + 1] = chapters[k].sections[j]
            chapters[k].sections[j] = tmp
            break
          }
        }
      }
    }
  },
  watermark (settings) {
    //默认设置
    var defaultSettings = {
      watermark_txt: "text",
      watermark_x: 20,//水印起始位置x轴坐标
      watermark_y: 20,//水印起始位置Y轴坐标
      watermark_rows: 5,//水印行数
      watermark_cols: 10,//水印列数
      watermark_x_space: 100,//水印x轴间隔
      watermark_y_space: 100,//水印y轴间隔
      watermark_color: '#E0E0E0',//水印字体颜色
      watermark_alpha: 0.4,//水印透明度
      watermark_fontsize: '15px',//水印字体大小
      watermark_font: '微软雅黑',//水印字体
      watermark_width: 210,//水印宽度
      watermark_height: 80,//水印长度
      watermark_angle: 15//水印倾斜度数
    };
    //采用配置项替换默认值，作用类似jquery.extend
    if (arguments.length === 1 && typeof arguments[0] === "object") {
      var src = arguments[0] || {};
      for (var keyS in src) {
        if (src[keyS] && defaultSettings[keyS] && src[keyS] === defaultSettings[keyS])
          continue;
        else if (src[keyS])
          defaultSettings[keyS] = src[keyS];
      }
    }

    var oTemp = document.createDocumentFragment();

    //获取页面最大宽度
    var page_width = Math.max(document.body.scrollWidth, document.body.clientWidth);
    var cutWidth = page_width * 0.0150;
    var page_width = page_width - cutWidth;
    //获取页面最大高度
    // var page_height = Math.max(document.body.scrollHeight, document.body.clientHeight) + 650;
    var page_height = Math.max(document.body.scrollHeight, document.body.clientHeight);
    // var page_height = document.body.scrollHeight+document.body.scrollTop;
    //如果将水印列数设置为0，或水印列数设置过大，超过页面最大宽度，则重新计算水印列数和水印x轴间隔
    if (defaultSettings.watermark_cols == 0 || (parseInt(defaultSettings.watermark_x + defaultSettings.watermark_width * defaultSettings.watermark_cols + defaultSettings.watermark_x_space * (defaultSettings.watermark_cols - 1)) > page_width)) {
      defaultSettings.watermark_cols = parseInt((page_width - defaultSettings.watermark_x + defaultSettings.watermark_x_space) / (defaultSettings.watermark_width + defaultSettings.watermark_x_space) - 1);
      defaultSettings.watermark_x_space = parseInt((page_width - defaultSettings.watermark_x - defaultSettings.watermark_width * defaultSettings.watermark_cols) / (defaultSettings.watermark_cols - 1) - 10);
    }
    //如果将水印行数设置为0，或水印行数设置过大，超过页面最大长度，则重新计算水印行数和水印y轴间隔
    if (defaultSettings.watermark_rows == 0 || (parseInt(defaultSettings.watermark_y + defaultSettings.watermark_height * defaultSettings.watermark_rows + defaultSettings.watermark_y_space * (defaultSettings.watermark_rows - 1)) > page_height)) {
      defaultSettings.watermark_rows = parseInt((defaultSettings.watermark_y_space + page_height - defaultSettings.watermark_y) / (defaultSettings.watermark_height + defaultSettings.watermark_y_space));
      defaultSettings.watermark_y_space = parseInt(((page_height - defaultSettings.watermark_y) - defaultSettings.watermark_height * defaultSettings.watermark_rows) / (defaultSettings.watermark_rows - 1));
    }
    var x;
    var y;
    for (var i = 0; i < defaultSettings.watermark_rows; i++) {
      y = defaultSettings.watermark_y + (defaultSettings.watermark_y_space + defaultSettings.watermark_height) * i;
      for (var j = 0; j < defaultSettings.watermark_cols; j++) {
        x = defaultSettings.watermark_x + (defaultSettings.watermark_width + defaultSettings.watermark_x_space) * j;

        var mask_div = document.createElement('div');
        mask_div.id = 'mask_div' + i + j;
        mask_div.className = 'mask_div';
        mask_div.appendChild(document.createTextNode(defaultSettings.watermark_txt));
        //设置水印div倾斜显示
        mask_div.style.webkitTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
        mask_div.style.MozTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
        mask_div.style.msTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
        mask_div.style.OTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
        mask_div.style.transform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
        mask_div.style.visibility = "";
        mask_div.style.position = "absolute";
        mask_div.style.left = x + 'px';
        mask_div.style.top = y + 'px';
        mask_div.style.overflow = "hidden";
        mask_div.style.zIndex = "9999";
        mask_div.style.pointerEvents = 'none';//pointer-events:none  让水印不遮挡页面的点击事件
        //mask_div.style.border="solid #eee 1px";
        mask_div.style.opacity = defaultSettings.watermark_alpha;
        mask_div.style.fontSize = defaultSettings.watermark_fontsize;
        mask_div.style.fontFamily = defaultSettings.watermark_font;
        mask_div.style.color = defaultSettings.watermark_color;
        mask_div.style.textAlign = "center";
        mask_div.style.width = defaultSettings.watermark_width + 'px';
        mask_div.style.height = defaultSettings.watermark_height - 105 + 'px';
        mask_div.style.display = "block";
        oTemp.appendChild(mask_div);
      };
    };
    document.body.appendChild(oTemp);
  },
  setCharOnIndex (string, index, char) {
    if (index > string.length - 1) return string;
    return string.substring(0, index) + char + string.substring(index + 1);
  },
  ppt (txt) {
    // txt = txt.replace(/</g, "&lt;")
    let a = txt.split('\n')

    let headFlag = true
    let firstFlag = true
    let res = ''

    for (let i = 0; i < a.length; i++) {
      let tmp = a[i]
      // console.log(tmp)
      if (headFlag) {
        if (tmp.search('background') != -1) {
          if (tmp.search('http') != -1) {
            if (tmp[0] == '!') {
              for (let j = 0; j < tmp.length; j++) {
                if (tmp[j] == '(' || tmp[j] == ')') {
                  // tmp[j] = '"'
                  tmp = this.setCharOnIndex(tmp, j, '"')
                }
              }
              res += '<section data-markdown data-background-image=' + tmp.split(']')[1] + '>\n'
            } else {
              res += '<section data-markdown data-background-image=' + tmp.split(': ')[1] + '>\n'
            }
          } else {
            res += '<section data-markdown data-background-color=' + tmp.split(': ')[1] + '>\n'
          }
          res += '<textarea data-template>\n'
        }
      } else if (tmp != '---') {
        // if (tmp == '```c++') {
        //   // res += '<pre><code data-line-numbers class="cpp">'
        //   res += tmp + ' data-line-numbers\n'
        // } else if (tmp == '```cpp') {
        //   res += '<pre><code data-line-numbers class="cpp">'
        // } else if (tmp == '```python') {
        //   res += '<pre><code data-line-numbers class="py">'
        // } else if (tmp == '```py') {
        //   res += '<pre><code data-line-numbers class="py">'
        // } else if (tmp == '```') {
        //   // res = res.slice(0, res.length - 1) + '</code></pre>\n'
        //   res += tmp + '\n'
        // } else {
        //   res += tmp + '\n'
        // }
        res += tmp + '\n'
      }

      if (tmp == '---') {
        let flag = true
        if (i + 1 < a.length) {
          let tmpy = a[i + 1].trim()
          if (tmpy.search('background:') != -1 || tmpy.search('theme:') != -1 || tmpy.search('layout:') != -1 || tmpy.search('background]') != -1) {
            flag = false
          }
        }

        if (i >= 2) {
          let tmpy = a[i - 2].trim()
          if (tmpy.search('background:') != -1 || tmpy.search('theme:') != -1 || tmpy.search('layout:') != -1 || tmpy.search('background]') != -1) {
            flag = false
          }
        }

        if (flag) {
          res += tmp + '\n'
        }
        headFlag = false
      }

      if (tmp == '---') {
        let tmpy = a[i + 1].trim()
        if (tmpy.search('background:') != -1 || tmpy.search('theme:') != -1 || tmpy.search('layout:') != -1 || tmpy.search('background]') != -1) {
          headFlag = true

          if (!firstFlag || tmpy.search('[background]') != -1) {
            res += '</textarea>\n</section>\n\n\n'
          }
          firstFlag = false
        }
      }
    }
    res += '</textarea>\n</section>\n'
    // res = res.replace(/<\//g, "&lt;/")
    // console.log(res)
    return res
  }
}
